// extracted by mini-css-extract-plugin
export default {"transfer":"transfer_transfer__+k99H"};